/* Copyright (c) 2026 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useMemo } from "react";
import { ActionScope, PlanSortFields, SortOrder } from "~/generated/graphql";
import { createValueLabelMap } from "~/hooks/useAppliedFilters/utils";
import { useGetPlanNames } from "~/views/plans/hooks/useGetPlanNames/useGetPlanNames";
import { createCustomActionAppliedFilters } from "../components/customActionAppliedFilters";
import { getScope } from "../components/types";
import { ACTION_TYPE_LABEL_MAP } from "../constants";

const typeLabelsByValue = ACTION_TYPE_LABEL_MAP as Record<string, string>;

const scopeLabelsByValue = Object.values(ActionScope).reduce<
  Record<string, string>
>(
  (accumulator, scope) => ({
    ...accumulator,
    [scope]: getScope(scope),
  }),
  {}
);

export function useCustomActionsAppliedFilters() {
  const { data: plans } = useGetPlanNames({
    page: "1",
    limit: "1000",
    sort: {
      field: PlanSortFields.Name,
      order: SortOrder.Asc,
    },
  });

  const planNamesById = useMemo(
    () =>
      createValueLabelMap(
        plans,
        (plan) => plan.id,
        (plan) => plan.name
      ),
    [plans]
  );

  return useMemo(
    () =>
      createCustomActionAppliedFilters({
        planNamesById,
        typeLabelsByValue,
        scopeLabelsByValue,
      }),
    [planNamesById]
  );
}
